import React, { FC } from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { columnStyle, tableHeadingStyle } from "./TableHeading.styles";
import "./TableHeading.scss";
const TableHeading: FC<{
  showInputField?: boolean;
  onInput?: (e) => void;
  columns: string[];
}> = ({ showInputField, columns, onInput }) => {
  return (
    <TableHead style={tableHeadingStyle}>
      <TableRow>
        {showInputField && (
          <TableCell style={columnStyle}>
            <input
              className="table-heading__search-clubs"
              type="text"
              placeholder="Search clubs"
              onChange={(e) => onInput!(e)}
            />
          </TableCell>
        )}
        {columns.map((column) => {
          return (
            <TableCell align="center" key={column} style={columnStyle}>
              <p style={{ color: "white" }}>{column}</p>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default TableHeading;
